import { makeAutoObservable } from 'mobx';
import {PerformanceReviewTemplate} from 'main/stores/performance_reviews';
import {DomainStore} from 'shared/store';
import {t} from 'shared/core';
import {endpoints, types} from 'main/tools';

class TemplateState {
  store = new DomainStore();
  history;

  newTemplate;
  errors = {};

  constructor() {
    makeAutoObservable(this, {
      store: false,
      history: false
    });
  }

  receiveProps({history}) {
    this.history = history;
  }

  async createNewTemplate() {
    this.newTemplate = new PerformanceReviewTemplate({
      name: t('performance_reviews.Untitled question set')
    });
    const {model, errors} = await this.store.post(
      endpoints.REVIEW_TEMPLATES.ALL,
      types.PERFORMANCE_REVIEWS.TEMPLATE,
      this.newTemplate
    );
    this.errors = errors;

    if (model) {
      this.goToTemplate(model.id);
    }
  }

  async removeTemplate(template) {
    await this.store.destroy(template);
  }

  async duplicateTemplate(template) {
    const {model} = await this.store.post(
      endpoints.REVIEW_TEMPLATE.DUPLICATE.with(template.id),
      types.PERFORMANCE_REVIEWS.TEMPLATE
    );

    this.goToTemplate(model.id);
  }

  goToTemplate(id) {
    this.history.push(`/question_sets/${id}`);
  }
}

export default TemplateState;
